module.exports = __webpack_public_path__ + "fonts/8451bfc.ttf";